import { all, call, spawn } from 'redux-saga/effects'

import { NODE_START } from './content/nodes/start/constants'
import { CONTENT_NODE_BLOCKLIST_BASE_PATHS } from './content/utils/verify'

import ContentProduct from './content/product/operations'
import ContentNamespace from './content/namespace/operations'
import NodeContentStartSaga from './content/nodes/start/operations'
import NodeContentNextSaga from './content/nodes/next/operations'
import FailureChecker from './content/nodes/failureChecker/operations'

const registeredNamespace = NODE_START

// This function can be used to dynamically blocklist certain routes or route patterns
function getBlocklist() {
  // Always blocklist these routes - they use PagesV2Container with content-np service and program flex
  // Uses central CONTENT_NODE_BLOCKLIST_BASE_PATHS list and adds wildcards for isOnPathBlocklist compatibility
  const blocklist = CONTENT_NODE_BLOCKLIST_BASE_PATHS.map(
    basePath => `${basePath}/*`,
  )

  return blocklist
}

const WatchNodeStart = new NodeContentStartSaga(
  registeredNamespace,
  getBlocklist,
)
const WatchProductNavigation = new ContentProduct()
const WatchNamespaceNavigation = new ContentNamespace()
const WatchNodeNext = new NodeContentNextSaga(registeredNamespace, getBlocklist)
const WatchFailures = new FailureChecker()

export default function* learnSagas() {
  const sagas = [
    WatchProductNavigation.subscribe,
    WatchNamespaceNavigation.subscribe,
    WatchNodeStart.subscribe,
    WatchNodeNext.subscribe,
    WatchFailures.subscribe,
  ]

  yield all(
    sagas.map(saga =>
      spawn(function*() {
        while (true) {
          try {
            yield call(saga)
            break
          } catch (e) {
            console.error('LEARN SAGA SPAWN FAIL:', e)
          }
        }
      }),
    ),
  )
}
